import Image from "next/image";
import { FaCheck } from "react-icons/fa6";
import Subtitle from "../ui/subtitle";
import clsx from "clsx";

const Why = ({ title, subtitle, description, list, image, reverse }) => {
  return (
    <section className="bg-gradient-to-tl from-violet-100 via-white pb-20 pt-10 lg:pt-10">
      <div className="mx-auto max-w-screen-xl px-5">
        <div className={clsx(
          "flex w-full flex-col-reverse gap-10 lg:flex-row lg:justify-between", 
          reverse && "lg:!flex-row-reverse"
          )}>
          <div className="lg:w-2/3">
            <Subtitle
              custom="mx-auto text-center lg:text-left"
              subtitle={title}
              gradientTextColor="from-violet-500 via-violet-600 to-violet-700"
              textColor="text-violet-500"
            />
            <h2 className="mb-2.5 text-center lg:text-left text-3xl font-bold tracking-tight text-slate-900 md:text-5xl !leading-tight">
              {subtitle}
            </h2>
            <p className="text-center lg:text-left lg:text-lg">{description}</p>
          </div>
          <div className="lg:w-1/3">
            <Image
              quality={100}
              src={image}
              className="max-h-[367px] object-contain"
              alt="SEO Clicks and Impressions"
              width={400}
              height={267}
            />
          </div>
        </div>
        {list ? (
          <div className="mt-10 grid gap-10 lg:grid-cols-2">
            {list.map((item) => (
              <div key={item.title}>
                <h4 className="mb-2.5 items-center gap-2.5 text-center text-xl font-semibold lg:text-left">
                  <FaCheck className="mr-1.5 inline text-purple-500" />
                  {item.title}
                </h4>
                <p className="text-center opacity-90 lg:text-left">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default Why;
